import { getRequest, postRequest, deleteRequest, patchRequest } from './helper';

export const API = {
  get: getRequest,
  post: (url, data) => postRequest(url, data),
  put: (url, data) => postRequest(url, data), // Project mostly uses postRequest for mutations
  delete: deleteRequest,
  patch: patchRequest,
};
